import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumDiscountBasis implements BaseEnumType {
  private static allValues: EnumDiscountBasis[] = []; // make sure this is top-most
  
  public static none = new EnumDiscountBasis(0, "None", "enum_discount_basis_none");
  public static percent = new EnumDiscountBasis(1, "Percent", "enum_discount_basis_percent");
  public static currencyPerUnit = new EnumDiscountBasis(2, "CurrencyPerUnit", "enum_discount_basis_currency_per_unit");
  public static currencyPerBarrel = new EnumDiscountBasis(3, "CurrencyPerBarrel", "enum_discount_basis_currency_per_barrel");
  public static currencyPerLitre = new EnumDiscountBasis(4, "CurrencyPerLitre", "enum_discount_basis_currency_per_litre");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumDiscountBasis.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isNone() { return this === EnumDiscountBasis.none; }
  public isPercent() { return this === EnumDiscountBasis.percent; }
  public isCurrencyPerUnit() { return this === EnumDiscountBasis.currencyPerUnit; }
  public isCurrencyPerBarrel() { return this === EnumDiscountBasis.currencyPerBarrel; }
  public isCurrencyPerLitre() { return this === EnumDiscountBasis.currencyPerLitre; }

  public static getValues(): readonly EnumDiscountBasis[] {
    return EnumDiscountBasis.allValues;
  }

  public static getValuesExcept0(): readonly EnumDiscountBasis[] {
    return EnumDiscountBasis.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumDiscountBasis {
    const found = EnumDiscountBasis.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumDiscountBasis - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumDiscountBasis): EnumDiscountBasis {
    const found = name ? EnumDiscountBasis.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumDiscountBasis - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumDiscountBasis>): boolean {
    return this.key === other?.key;
  }
}